import { render, staticRenderFns } from "./words.vue?vue&type=template&id=b3e40a52&"
import script from "./words.vue?vue&type=script&lang=js&"
export * from "./words.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports